import { useMutation } from "react-query";
import { postWithBearer } from "utils/authApi";
import { API_LOGIN_SET_PASSWORD } from "consts";

export default function useLoginSetPassword(config) {
  return useMutation(
    ({ accessToken, newPassword, confirmPassword }) =>
      postWithBearer(
        API_LOGIN_SET_PASSWORD,
        { newPassword, confirmPassword },
        accessToken
      ),
    config
  );
}
